import StackCarousel from "../../../../src/@lekoarts/gatsby-theme-minimal-blog/components/stack-carousel";
import LinksCarousel from "../../../../src/@lekoarts/gatsby-theme-minimal-blog/components/links-carousel";
import * as React from 'react';
export default {
  StackCarousel,
  LinksCarousel,
  React
};